// extracted by mini-css-extract-plugin
module.exports = {"container":"TopTitle-module--container--1xVwM"};